import { PageId } from 'constants/pages'

export const enum PageIdStylioCmp {
  AGE_CMP = PageId.AGE_CMP,
  STYLIO_TO_HELP_CMP = PageId.STYLIO_TO_HELP_CMP,
  MAIN_GOAL_CMP = PageId.MAIN_GOAL_CMP,
  WHERE_TO_SHOP_CMP = PageId.WHERE_TO_SHOP_CMP,
  WARDROBE_PERCENTAGE_CMP = PageId.WARDROBE_PERCENTAGE_CMP,
  HAIR_COLOR_CMP = PageId.HAIR_COLOR_CMP,
  EYES_COLOR_CMP = PageId.EYES_COLOR_CMP,
  BODY_SHAPE_CMP = PageId.BODY_SHAPE_CMP,
  URGE_1_CMP = PageId.URGE_1_CMP,
  URGE_2_CMP = PageId.URGE_2_CMP,
  URGE_3_CMP = PageId.URGE_3_CMP,
  URGE_4_CMP = PageId.URGE_4_CMP,
  URGE_5_CMP = PageId.URGE_5_CMP,
  URGE_6_CMP = PageId.URGE_6_CMP,
  FACE_SCAN_INTRO_CMP = PageId.FACE_SCAN_INTRO_CMP,
  FACE_SCAN_ANALYSIS_CMP = PageId.FACE_SCAN_ANALYSIS_CMP,
  URGE_7_CMP = PageId.URGE_7_CMP,
  URGE_8_CMP = PageId.URGE_8_CMP,
  STYLE_PROFILE_CMP = PageId.STYLE_PROFILE_CMP,
  WARDROBE_READY_CMP = PageId.WARDROBE_READY_CMP,
  NOTHING_TO_WEAR_CMP = PageId.NOTHING_TO_WEAR_CMP,
  WARDROBE_FEEL_CMP = PageId.WARDROBE_FEEL_CMP,
  SHOPPING_CMP = PageId.SHOPPING_CMP,
  SHOPPING_BUDGET_CMP = PageId.SHOPPING_BUDGET_CMP,
  SHOPPING_PRIORITY_CMP = PageId.SHOPPING_PRIORITY_CMP,
  AMAZON_FRUSTRATION_CMP = PageId.AMAZON_FRUSTRATION_CMP,
  CURATED_LINKS_CMP = PageId.CURATED_LINKS_CMP,
  LIFESTYLE_FOCUS_CMP = PageId.LIFESTYLE_FOCUS_CMP,
  OUTFIT_NEEDS_CMP = PageId.OUTFIT_NEEDS_CMP,
  WARDROBE_ALIGNS_CMP = PageId.WARDROBE_ALIGNS_CMP,
  LIFESTYLE_CHANGES_CMP = PageId.LIFESTYLE_CHANGES_CMP,
  STYLE_DRAWN_TO_CMP = PageId.STYLE_DRAWN_TO_CMP,
  OUTFIT_EMOTION_CMP = PageId.OUTFIT_EMOTION_CMP,
  STYLE_DISCOVERY_CMP = PageId.STYLE_DISCOVERY_CMP,
  WARDROBE_COLORS_CMP = PageId.WARDROBE_COLORS_CMP,
  COLOR_CONFIDENCE_CMP = PageId.COLOR_CONFIDENCE_CMP,
  BODY_SHAPE_CONFIDENCE_CMP = PageId.BODY_SHAPE_CONFIDENCE_CMP,
  SHOW_OFF_FEATURES_CMP = PageId.SHOW_OFF_FEATURES_CMP,
  PREPARE_FLOW_CMP = PageId.PREPARE_FLOW_CMP,
  EMAIL_CMP = PageId.EMAIL_CMP,
  NAME_CMP = PageId.NAME_CMP,
  READINESS_LEVEL_CMP = PageId.READINESS_LEVEL_CMP,
  PRE_PAYWALL_OFFER_CMP = PageId.PRE_PAYWALL_OFFER_CMP,
  SUBSCRIPTIONS_CMP = PageId.SUBSCRIPTIONS_CMP,
  CANCEL_OFFER_CMP = PageId.CANCEL_OFFER_CMP,
  AI_STYLIST_UPSELL_CMP = PageId.AI_STYLIST_UPSELL_CMP,
  SUB_UPSELL_CMP = PageId.SUB_UPSELL_CMP,
  UPSELL_CMP = PageId.UPSELL_CMP,
  FACE_UPSELL_CMP = PageId.FACE_UPSELL_CMP,
  BUNDLE_UPSELL_CMP = PageId.BUNDLE_UPSELL_CMP,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_CMP = PageId.DOWNLOAD_CMP,
}
